import gmx_zMixins            from '../../../../../../../includes/Jmixins/zMixins'

// Locally declared common Data-Props & SVG Drawing Support
import lmx_localData          from '../primitives/localData'

import lmx_Watching           from './Watching'
import lmx_Events             from './Events'
import lmx_functions          from './func_Storage'
  
// Charts 
import lmx_LocalValues        from './set_LocalValues'
import lmx_draw_Forms         from './draw_Forms'



export default {
  
  mixins: [
    gmx_zMixins,
    lmx_localData,

    // Local Mixins
    lmx_Events,
    lmx_Watching,
    lmx_functions,

    lmx_LocalValues,
    lmx_draw_Forms,

  ],

}
